// Shows the results of the PREVIOUS rounds/deals of the current game (point table per round).
// Round 1 of a game has no history; from round 2 onwards earlier rounds are listed as tabs.
import React, { useEffect, useState } from 'react';
import PointTableModal from './PointTableModal';

export default function DealHistoryModal({ show, onClose, socket, gameId, gameState }) {
  const [history, setHistory] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const isPoints = gameState?.gameMode === 'points';
  const totalDeals = gameState?.totalDeals;
  const labelFor = (deal) => (isPoints ? `Round ${deal}` : `Deal ${deal}${totalDeals ? `/${totalDeals}` : ''}`);

  useEffect(() => {
    if (!show || !socket || !gameId) return;
    setLoading(true);
    socket.emit('get-deal-history', { gameId }, (res) => {
      const list = (res && res.success && Array.isArray(res.history)) ? res.history : [];
      // Hide the deal that is currently being played (only shown once it has completed)
      const finishedOnly = list.filter(h => h.deal < (gameState?.currentDeal || Infinity) ||
        gameState?.status === 'deal_completed' || gameState?.status === 'finished');
      setHistory(finishedOnly);
      setSelected(finishedOnly.length ? finishedOnly[finishedOnly.length - 1].deal : null);
      setLoading(false);
    });
  }, [show, socket, gameId, gameState?.currentDeal]);

  if (!show) return null;

  const current = history.find(h => h.deal === selected);

  const tabs = history.length > 0 && (
    <div style={{ display: 'flex', gap: 6, justifyContent: 'center', flexWrap: 'wrap', marginTop: 10 }}>
      {history.map(h => (
        <button
          key={h.deal}
          onClick={() => setSelected(h.deal)}
          style={{
            padding: '5px 12px', borderRadius: 14, cursor: 'pointer', fontSize: 12, fontWeight: 700,
            border: '1px solid rgba(255,255,255,0.25)',
            background: h.deal === selected ? '#4CAF50' : 'rgba(255,255,255,0.08)',
            color: '#fff'
          }}
        >
          {labelFor(h.deal)}
        </button>
      ))}
    </div>
  );

  if (!current) {
    return (
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ background: '#1a1a2e', borderRadius: 14, padding: '24px 28px', textAlign: 'center', color: '#fff', maxWidth: 360, width: '90%' }}
        >
          <h3 style={{ margin: '0 0 8px 0' }}>Previous rounds</h3>
          <p style={{ margin: '0 0 16px 0', color: '#bbb', fontSize: 14 }}>
            {loading ? 'Loading…' : 'No completed rounds yet. Results appear here from the second round.'}
          </p>
          <button
            onClick={onClose}
            style={{ background: '#607d8b', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 20px', fontWeight: 700, cursor: 'pointer' }}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <PointTableModal
      show
      onClose={onClose}
      pointTable={current.pointTable}
      title={`📊 ${labelFor(current.deal)} — Result`}
      message="Previous round"
      gameOver
      light
      headerExtra={tabs}
    />
  );
}
